import React from 'react';
import Text from 'components/Text';
import styled from 'styled-components';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var TextMaxLines = styled(Text).withConfig({
  displayName: "Description__TextMaxLines",
  componentId: "sc-1qhtzr9-0"
})(["", ";"], function (props) {
  return props.maxLines && "\n\t\tdisplay: -webkit-box;\n\t\t-webkit-line-clamp: ".concat(props.maxLines, ";\n\t\t-webkit-box-orient: vertical;\n\t\toverflow: hidden;\n\t");
});
export default function Description(_ref) {
  var title = _ref.title,
    maxLines = _ref.maxLines,
    children = _ref.children;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Text, {
      as: "dt",
      overflow: "wrap",
      maxWidth: "100%",
      children: title
    }), /*#__PURE__*/_jsx(TextMaxLines, {
      as: "dd",
      overflow: "wrap",
      maxWidth: "100%",
      maxLines: maxLines,
      children: children
    })]
  });
}